import * as React from 'react';
import { Redirect, Route, RouteComponentProps } from 'react-router-dom';
import styled from 'styled-components';
import {
  isAuthenticated,
  userNotProvisionedProvider,
} from '../../data/providers/userProvider';
import Menu from '../pageHeader/PageHeader';
import { AccessPending } from '../auth/AccessPending';
import { TeamAccessCheck } from '../auth/TeamAccessCheck';
import { TeamWriteAccessCheck } from '../auth/TeamWriteAccessCheck';
import { ErrorBoundary } from '../shared/ErrorBoundary';
interface IProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  component: any;
  path?: string;
  exact?: boolean;
  writeOnly?: boolean;
}

const ProtectedLayout = ({
  component: Component,
  writeOnly,
  ...rest
}: IProps): React.ReactElement => {
  const [userNotProvisioned, setUserNotProvisioned] =
    React.useState<boolean>(false);

  React.useEffect(() => {
    const subscription = userNotProvisionedProvider().subscribe(
      (notProvisioned: boolean) => {
        setUserNotProvisioned(notProvisioned);
      }
    );

    return () => {
      subscription.unsubscribe();
    };
  }, []);

  const renderFn = (props: RouteComponentProps): React.ReactElement => {
    // Show access pending screen if user is authenticated but not provisioned
    if (isAuthenticated() && userNotProvisioned) {
      return <AccessPending />;
    }

    return isAuthenticated() ? (
      <React.Fragment>
        <ErrorBoundary>
          {writeOnly ? (
            <TeamWriteAccessCheck>
              <SkipLinks />
              <Menu />
              <Component {...props} />
            </TeamWriteAccessCheck>
          ) : (
            <TeamAccessCheck>
              <SkipLinks />
              <Menu />
              <Component {...props} />
            </TeamAccessCheck>
          )}
        </ErrorBoundary>
      </React.Fragment>
    ) : (
      <Redirect
        to={{
          pathname: '/',
          state: { from: props.location },
        }}
      />
    );
  };
  return <Route {...rest} render={renderFn} />;
};

export { ProtectedLayout };

const SkipLinks = () => {
  return (
    <React.Fragment>
      <SkipLink href='#entity-selection'>
        Skip to Team, Group, or Athlete Selection
      </SkipLink>
      <SkipLink href='#analyze'>Skip to Main Content</SkipLink>
      <SkipLink href='#secondary-menu'>Skip to Secondary Menu</SkipLink>
    </React.Fragment>
  );
};

const SkipLink = styled.a`
  position: absolute;
  left: -999px;
  width: 1px;
  height: 1px;
  top: auto;

  &:focus {
    color: var(--color-surface-0);
    display: inline-block;
    height: auto;
    width: auto;
    position: static;
    margin: auto;
  }
`;
